import { createSlice } from '@reduxjs/toolkit';

export const LAST_SITE_HASH_KEY = 'lastSiteHash';

const initialState = {
  currentProject: null,
  currentOrganization: null,
  projects: [],
  organizations: [],
  loaded: false,
  loadingProjects: false,
  error: null,
};

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setCurrentProject(state, action) {
      state.currentProject = action.payload;
      if (!action.payload?.hash) return;
      localStorage.setItem(LAST_SITE_HASH_KEY, action.payload.hash);
      const index = state.projects.findIndex((project) => project.hash === action.payload.hash);
      if (index >= 0) state.projects[index] = action.payload;
      else state.projects.unshift(action.payload);
    },
    setCurrentOrganization(state, action) {
      state.currentOrganization = action.payload;
    },
    setProjects(state, action) {
      state.projects = action.payload;
    },
    setOrganizations(state, action) {
      state.organizations = action.payload;
    },
    setLoaded(state, action) {
      state.loaded = action.payload;
    },
    setLoadingProjects(state, action) {
      state.loadingProjects = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    resetProject(state) {
      state.currentProject = null;
      state.currentOrganization = null;
      state.projects = [];
      state.loaded = false;
      state.loadingProjects = false;
    },
  },
});

export const {
  setCurrentProject,
  setCurrentOrganization,
  setProjects,
  setOrganizations,
  setLoaded,
  setLoadingProjects,
  setError,
  resetProject,
} = projectSlice.actions;

export default projectSlice.reducer;
